import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams, useLocation } from 'react-router-dom'

import { getCourseURL } from '@/reducers/baltoAcademy/baltoAcademy.actions'
import { Loader } from '@/components/loaders/Loader'
import { PageHeader } from '@/components/headers/PageHeader'

import './BaltoAcademyCoursePage.scss'

const BaltoAcademyCoursePage = () => {
  const dispatch = useDispatch()
  const { loading, activeCourseURL } = useSelector((state) => state.baltoAcademy)
  const { username, organizationid } = useSelector((state) => state.currentUser)
  const { courseId } = useParams()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const title = params.get('title')

  useEffect(() => {
    if (username && organizationid) {
      dispatch(getCourseURL(courseId, username, organizationid))
    }
  }, [username, organizationid, courseId])

  return (
    <div className="balto-academy-course-page-container">
      <PageHeader title={title} />
      {loading && (
        <div data-testid="loading-spinner">
          <Loader centered />
        </div>
      )}
      {activeCourseURL && (
        <iframe src={activeCourseURL} data-testid="course-iframe" title={courseId} />
      )}
    </div>
  )
}

export default BaltoAcademyCoursePage
